import React, { Fragment } from "react"
import { GROUPS } from "./constants"

const WEEKS = ["1a settimana", "2a settimana", "3a settimana", "4a settimana", "5a settimana"]
const DAYS = ["Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì"]
const SLICES_ORIGINAL = ["pre", "post"]

const GroupTable = ({ state, week, setEditing, prePostMode }) => {
  const slices = SLICES_ORIGINAL.filter(item => item === prePostMode || prePostMode === "both")
  return (
    <table 
      style={{ width: "100%", borderCollapse: "collapse", marginTop: 15, tableLayout: "fixed" }}
      className={`custom-table mode-${prePostMode}`}
    >
      <thead>
        <tr>
          <th />
          {WEEKS.filter(w => w === week).map(w => (
            <th colSpan={DAYS.length * slices.length} key={w}>{w}</th>
          ))}
        </tr>
        <tr>
          <th />
          {WEEKS.filter(w => w === week).map(w => (
            <Fragment key={w}>
              {DAYS.map(d => (
                <th colSpan={slices.length} key={d}>{d}</th>
              ))}
            </Fragment>
          ))}
        </tr>
        <tr>
          <th />
          {WEEKS.filter(w => w === week).map(w => (
            <Fragment key={w}>
              {DAYS.map(d => (
                <Fragment key={d}>
                  {slices.map(sl => (
                    <th key={sl}>{sl}</th>
                  ))}
                </Fragment>
              ))}
            </Fragment>
          ))}
        </tr>
      </thead>
      <tbody>
        {GROUPS.map(g => (
          <tr key={g}>
            <th>{g}</th>
            {WEEKS.filter(w => w === week).map(w => (
              <Fragment key={w}>
                {DAYS.map(d => (
                  <Fragment key={d}>
                    {slices.map(sl => {
                      const record = state.find(record => record.group === g && record.week === w && record.day === d && record.slice === sl)
                      if (!record) {
                        return (
                          <td
                            key={sl}
                            onClick={() => setEditing({ group: g, space: null, week: w, day: d, slice: sl, activity: "" })}
                          />
                        )
                      }
                      return (
                        <td
                          key={sl}
                          onClick={() => setEditing(record)}
                        >
                          {record.activity} ({record.space})
                        </td>
                      )
                    })}
                  </Fragment>
                ))}
              </Fragment>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default GroupTable